import { fetchJson } from "../../../lib/Fetching";

function fetchSamples({
  company_id,
  company_branch_id,
  product_name,
  product_id,
  start_date,
  end_date,
  received,
  received_by_company_branch_id,
  invoice_status = "all",
  reviewed = "all",
  contractReviewed = "all",
  data_field_params,
  client_suite_id,
  protocol_id,
  matrix_id,
  sample_ids,
  technique_ids,
  found,
  exceed,
  outstanding_todos,
  testing_category_id,
  date_filter,
  include_contracted_techniques,
  require_contract_review,
  include_scheduling_information,
  scheduled_status,
  with_unallocated_sample_ledger_items = false,
  with_invoice_sent_sample_ledger_items = false,
  invoice_id,
  requires_notification_authorisation = false,
  awaiting_notification,
  result_notification_group_id,
  show_withdrawn_samples,
  analysis_started_more_than_24_hrs_since_time_sampled,
  analysis_started_less_than_24_hrs_since_time_sampled,
  laboratory_company_id,
  show_all_samples,
  job_id,
  fexp = false,
  without_prepayment_authorisation,
  requested_turnaround,
}) {
  return fetchJson("/lims_sample_reporting/samples.json", {
    company_id,
    form: {
      client_suite_id,
      shelf_life_protocol_id: protocol_id,
      company_ids: company_id ? [company_id] : [],
      company_branch_ids: company_branch_id ? [company_branch_id] : null,
      product_id,
      product_name,
      start_date: start_date ? start_date.format("YYYY-MM-DD") : null,
      end_date: end_date ? end_date.format("YYYY-MM-DD") : null,
      data_fields: data_field_params || [],
      received,
      received_by_company_branch_id,
      contract_reviewed: contractReviewed,
      reviewed,
      invoice_status,
      matrix_id,
      technique_ids,
      sample_ids,
      found,
      exceed,
      outstanding_todos,
      testing_category_id,
      date_filter: date_filter || "registered",
      include_contracted_techniques: include_contracted_techniques ? true : false,
      require_contract_review: require_contract_review == true ? true : false,
      include_scheduling_information: include_scheduling_information == true ? true : false,
      scheduled_status: scheduled_status ? scheduled_status : "all",
      with_unallocated_sample_ledger_items: with_unallocated_sample_ledger_items,
      with_invoice_sent_sample_ledger_items: with_invoice_sent_sample_ledger_items,
      invoice_id,
      requires_notification_authorisation,
      awaiting_notification,
      result_notification_group_id,
      show_withdrawn_samples,
      show_all_samples,
      analysis_started_more_than_24_hrs_since_time_sampled,
      analysis_started_less_than_24_hrs_since_time_sampled,
      laboratory_company_id,
      job_id,
      fexp,
      without_prepayment_authorisation,
      requested_turnaround,
    },
  }).then((json) => {
    return json.sample_list;
  });
}

export { fetchSamples };
